import Vue from 'vue'

export const chat = {
    namespaced: true,
    state: {
        messages: [],
        openedChat: true,
        openedUsersList: false
    },
    actions: {
        clearMessages({ commit }) { commit('clear'); },
        addMessage({ commit }, message) {
            commit('append', message);
        },
        toggleChat({ commit }) {
            commit('toggleChat');
        },
        toggleUsersList({ commit }) {
            commit('toggleUsersList');
        }
    },
    mutations: {
        clear(state) {
            Vue.set(state, 'messages', [])
        },
        append(state, message) {
            Vue.set(state, 'messages', [...state.messages, message])
        },
        toggleChat(state) {
            Vue.set(state, 'openedChat', !state.openedChat);
            Vue.set(state, 'openedUsersList', state.openedChat);
        },
        toggleUsersList(state) {
            Vue.set(state, 'openedUsersList', !state.openedUsersList);
            Vue.set(state, 'openedChat', state.openedUsersList);
        }
    },
    getters: {
        getMessages: state => state.messages,
        isChatOpen: state => state.openedChat,
        isUsersOpen: state => state.openedUsersList
    }
}